import gql from "graphql-tag";
export default gql`
query getServicesBySiteIdPaginatedV2($siteId: String! $limit: Int, $nextToken: String){
    getServicesBySiteIdPaginatedV2(siteId: $siteId limit: $limit nextToken: $nextToken){
      items{
      serviceName
      slugName
      serviceStatus
      serviceDes
      attachedCat
      goodInventory
      siteId
      badInventory
      metaKeyword
      tax
      taxType
      itemType
      tags
      dishInstructions
      weightItem
      displayOrder
      masterProdId
      itemUnit
      attachedAddonCat
      pmInventory
      departmentId
      purchaseItemRef
      noDiscountItem
      costPrice
      availableInventory
      isInventory
      station
      externalSystemId
      hsnCode
      incentiveType
      incentiveValue
      attachedSpecialTags{
          tagName
          validFrom
          validTill
          visibleOn
          icon {
            bucket
            key
            region
          }
}
      addons{
        categoryName
         rule
         isRequired
         requiredNum
         customNum
         itemIds
         totalMaxQty
         totalMinQty
      }
          attachedVariations {
          serviceName
          slugName
          costPrice
          pmInventory
          serviceRates {
            serviceType
            rate
            listRate
            status
            inStock
          }
        }
      serviceRates{
        serviceType
        rate
        listRate
        status
        inStock
        costPrice
      }
      image {
        bucket
        region
        key
      }
    
      }, 
      nextToken
    }
  }`;
//    {
//    "siteId": "58496ae2-1ed7-4888-a168-1ba69a7a61b9"
//  }
